
        module.exports = __webpack_public_path__ + "assets/images/favicon_nl.3f0d8a05.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 96,
            height: 96,
            type: "png",
            bytes: 1593,

            toString: function() {
                return src;
            }
        };
    